var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormModal',{attrs:{"title":"Condition d'emballage","show-back-btn":""},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('PackingConditionsAssemblyDateFormStep',{attrs:{"progress-value":_vm.progressValue}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }